import textColorBasedOnBackground from "src/utils/textColorBasedOnBackground";
import styled, {css} from "styled-components";

interface IContainer{
  placeholderProp?: boolean;
  horizontal?: boolean;
  hover?: boolean;
  scrollable?: boolean;
  shadow?: boolean;
  widthFlex?: boolean;
  noStyle?: boolean;
  isDefaultColumn?: boolean;
}

export const WrapContainer = styled.div<IContainer>`
  display: flex;
  flex-direction: column;
  grid-auto-rows: max-content;
  overflow: hidden;
  box-sizing: border-box;
  appearance: none;
  outline: none;
  height: 97%;
  max-width: ${(props) => props.isDefaultColumn ? "" : "350px"};
  width: ${(props) => props.isDefaultColumn ? "100%" : ""};
  border: 1px solid rgba(0, 0, 0, 0.05);
  
  ${(props) => props.widthFlex ? css`   
    margin: 0px;
    width: 100%;
    height: 100%;
    overflow-x: scroll;
  `: css`
    min-width: 350px; 
    margin: 10px;
    ul{
      padding: 10px;
    }
  `}

  border-radius: 5px;
  min-height: 200px;
  transition: background-color 350ms ease;
  background-color: var(--header-color);
  
  font-size: 1em;

  ${(props) => props.placeholderProp ? css`
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: rgba(255, 255, 225, 0.8);
    background-color: transparent;
    border-style: dashed;
    border-color: rgba(0, 0, 0, 0.08);
    
    &:hover{
      background-color: #00000008;
    }

  ` : ""} 

  ${(props) => props.horizontal  ? css`
    width: 100%;
  ` : ""} 

  ${(props) => props.hover  ? css`
    background-color: rgb(245, 245, 245, 1);
  ` : ""} 

  ${(props) => props.scrollable  ? css`
    ul {
        overflow-y: auto;
      }
  ` : ""} 

  ${(props) => props.shadow  ? css`
    box-shadow: 0 1px 10px 0 rgba(34, 33, 81, 0.1);
  ` : ""} 

  ul {
    grid-gap: 5px;
    grid-template-columns: repeat(var(--columns, 1), 1fr);
    list-style: none;
    margin: 0;
    padding: 5px;
  }
`;

export const Label = styled.div`
  background: ${(props) => `${props.color}` ?? "#d3d3d3"};
  color: ${(props) => `${textColorBasedOnBackground(props.color ?? "#d3d3d3")} !important}` };
  border-radius: 5px; 
  font-size: 1rem;
  font-weight: 500;
  font-size: 0.8rem;
  line-height: 20px;
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  overflow: hidden;
  span{ 
    padding: 3px 12px;
  }
`;

export const Header = styled.div`
  display: flex;
  padding: 0px 20px;
  padding-right: 8px;
  align-items: center;
  justify-content: space-between;
  background-color: var(--header-color);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  min-height: 44px; 
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`;

export const Actions = styled.div`
  display: flex;
`;

export const Textarea = styled.input`
  background: var(--input-background-color);
  border: 2px solid ${(props) => `${props.color}` ?? "#d3d3d3"};
  border-radius: 5px;
  width: 100%;
  padding: 0px 12px;
  font-weight: 500;
  font-size: 0.8rem;
  line-height: 20px;
  width: 100%;
`;

export const CounterNumberOfItems = styled.div`
  align-self: center;
  font-size: 0.8rem;
  text-align: center;
  margin: 0 8px;
`;

